/**
    顶部路由组件
    参数：
*/
<template>
  <div>
    <el-row align="middle" type="flex" class="container">
      <el-col :offset="4" :span="4" class="logo-container">
        <el-image class="header-logo" src="http://www.bycz.com.cn/static/images/logoSmall.jpg" alt="logo" />
      </el-col>
      <el-col class="menu-container" :span="12">
        <el-menu
          :default-active="activeIndex"
          mode="horizontal"
          @select="handleSelect"
          background-color="#333333"
          active-text-color="#fae6a9"
          text-color="#ccc"
        >
          <el-menu-item
            v-for="item in this.navbar"
            :key="item.id"
            :index="item.id + ''"
          >{{item.name}}</el-menu-item>
        </el-menu>
        <!-- <div
          class="menu-container"
          v-for="item in this.navbar"
          :key="item.id"
          @click="routLinkTo(item.url,item.id)"
        >
          <div
            class="personalText"
            v-if="item.name != ''"
            :class="{active_path : active === item.id}"
            @mouseleave="mouseLeave(item.id)"
            @mouseover="mouseOver(item.id)"
            v-bind:id="item.id"
          >{{ item.name }}</div>
        </div>-->
      </el-col>
      <el-col :span="4" class="right-container">
        <el-row type="flex" align="middle" justify="center">
          <el-col class="qr-container" :span="8">
            <el-image class="qr-image" :src="this.deficon" />
          </el-col>
          <el-col :span="13">
            <el-row :gutter="8" type="flex" justify="space-around">
              <el-col>
                <i class="iconfont icon-xiaochengxu" style="color:#c8a74a" @mouseover="hovesmal()"></i>
              </el-col>
              <el-col>
                <i class="iconfont icon-weixin" @mouseover="hoveswx()"></i>
              </el-col>
              <el-col>
                <i class="iconfont icon-app" @mouseover="hoveapp()"></i>
              </el-col>
            </el-row>
            <el-row class="phone-container">
              <i class="el-icon-phone-outline">400-6810-018</i>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'TopTypeNav',
  props: {
    obj: Object,
    navbar: Array,
    righticon: Object
    // deficon: 'https://image.jdzapp.com/20216200245879889.png'
  },
  data() {
    return {
      activeIndex: '0',
      // active: '/indexpage/index',
      deficon: 'https://image.jdzapp.com/20216200245879889.png',
      arrs: {
        type: [
          {
            value: 0,
            des: '首页',
            route: '/indexpage/index'
          },
          {
            value: 1,
            des: '伯艺木门',
            route: '/indexpage/productlist'
          },
          {
            value: 2,
            des: '定制家',
            route: '/indexpage/seckill'
          },
          {
            value: 3,
            des: '伯艺居',
            route: '/articles'
          },
          // {
          //   'value': 4,
          //   'des': '折扣专区',
          //   'route': '/indexpage/discount'
          // },
          {
            value: 4,
            des: '体验店',
            route: '/indexpage/getcoupon'
          },
          {
            value: 5,
            des: '伯艺新闻',
            route: '/indexpage/noticedetail'
          },
          {
            value: 6,
            des: '三分钟了解伯艺',
            route: '/indexpage/noticedetail'
          },
          {
            value: 7,
            des: '联系我们',
            route: '/indexpage/noticedetail'
          }
        ]
      },
      searchKeyWord: ''
    }
  },
  watch: {
    $route(to, from) {
      let match = this.navbar.find((item) => {
        return item.url === to.fullPath
      })
      if (match) {
        this.activeIndex = match.id + ''
        return
      }
      match = this.navbar.find((item) => {
        return item.url === to.path
      })
      this.activeIndex = match.id + ''
    },
    navbar() {
      const to = this.$route
      let match = this.navbar.find((item) => {
        return item.url === to.fullPath
      })
      if (match) {
        this.activeIndex = match.id + ''
        return
      }
      match = this.navbar.find((item) => {
        return item.url === to.path
      })
      this.activeIndex = match.id + ''
    },
    obj: {
      // handler(nVal, oVal) {
      //   var data = nVal.componentContent.typeRoute
      //   this.arrs.type = data.map((item, index) => {
      //     return {
      //       value: index,
      //       des: item.des,
      //       route: item.linkTo
      //     }
      //   })
      // }
    }
  },

  methods: {
    hovesmal: function () {
      this.deficon = this.righticon.wechatApp.pic
    },
    hoveswx: function () {
      this.deficon = this.righticon.wechatPublic.pic
    },
    hoveapp: function () {
      this.deficon = this.righticon.APP.pic
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
      this.activeIndex = key
      let match = this.navbar.find((item) => {
        return item.id + '' === key
      })
      this.$router.push(match.url)
    },
    routLinkTo(val, ids) {
      this.active = ids
      // if (!val || val === this.$route.path) return
      this.$router.push(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100px;
  background-color: #333333;
  .logo-container {
    text-align: center;
    .header-logo {
      width: 200px;
      // height: 56px;
    }
  }
}
.menu-container {
  border-left: 1px solid #292929;
  border-right: 1px solid #292929;

  .el-menu.el-menu--horizontal {
    border: none;
    margin-left: 32px;
    margin-right: 32px;
    .el-menu-item {
      padding: 0 12px;
    }
  }
}
.right-container {
  color: #ccc;
  .qr-container {
    text-align: center;
    .qr-image {
      width: 60px;
      height: 60px;
    }
  }
  .iconfont {
    font-size: 27px;
  }
  .phone-container {
    margin-top: 8px;
  }
}

// .TRouteNav {
//   height: 100px;
//   // line-height: 100px;
//   background-color: #333333;
//   .wrapper {
//     max-width: 1440px;
//     min-width: 1440px;
//     margin: auto;
//     div {
//       display: inline-block;
//     }
//     .TPNleft {
//       cursor: pointer;
//       margin-left: 135px;
//       .headerLogo {
//         position: absolute;
//         top: 22px;
//       }
//     }
//     .TPNright {
//       // float: right;
//       // margin-right: 384px;
//       cursor: pointer;
//       color: #666666;
//       font-size: 16px;
//       font-family: PingFang SC;
//       font-weight: 400;
//       position: absolute;
//       top: 2px;
//       left: 590px;
//       padding: 0 20px 0 20px;
//       border-left: 1px solid #292929;
//       border-right: 1px solid #292929;
//       height: 89px;
//       .content {
//         margin-right: 30px;
//         .personalText {
//           font-size: 14px;
//           height: 80px;
//           color: #ccc;
//           border-bottom: none;
//         }
//         .active_path {
//           font-size: 14px;
//           color: #fae6a9;
//           border-bottom: 2px solid #fae6a9;
//         }
//         .hoverstyle {
//           font-size: 14px;
//           height: 80px;
//           color: #fae6a9;
//           border-bottom: 2px solid #fae6a9;
//         }
//         .newtest {
//           font-size: 14px;
//           color: #ccc;
//           border-bottom: none;
//         }
//       }
//       .searchItem {
//         margin: 0;
//         padding: 0;
//         input {
//           width: 220px;
//           height: 34px;
//           padding-left: 20px;
//           background-color: #f6f6f8;
//         }
//         button {
//           font-size: 16px;
//           width: 62px;
//           height: 34px;
//           color: #ffffff;
//           background-color: #333333;
//           cursor: pointer;
//         }
//       }
//     }
//     .RightInlet {
//       display: block;
//       height: 60px;
//       width: 231px;
//       // background-color: red;
//       position: absolute;
//       top: 24px;
//       left: 1350px;
//       .headerLogo {
//         width: 60px;
//       }
//       ul {
//         position: absolute;
//         top: -34px;
//         left: 78px;
//         li {
//           color: #ccc;
//           float: left;
//           i {
//             margin-left: 20px;
//             font-size: 27px;
//           }
//         }
//       }
//     }
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/common/TopTypeNav.vue